import React from "react";
import { Link } from "react-router-dom";

import {
  useGetGalleryImagesQuery,
  useDeleteGalleryImageMutation,
} from "./galleryImagesApiSlice";

const GalleryImageList = () => {

  const {
    data,
    isLoading,
    isSuccess,
    isError,
    error,
    refetch,
  } = useGetGalleryImagesQuery({
    page: 1,
    limit: 50,
  });

  const [deleteGalleryImage, { isLoading: isDeleting }] =
    useDeleteGalleryImageMutation();


  const handleDelete = async (id) => {

    if (!window.confirm("Delete this image?")) return;

    try {

      await deleteGalleryImage(id).unwrap();

      alert("Image deleted");

      refetch();

    } catch (err) {

      alert(err?.data?.message || "Delete failed");

    }

  };


  let content;


  // ========================
  // LOADING
  // ========================

  if (isLoading) {
    content = (
      <div className="text-center mt-4">
        <p>Loading images...</p>
      </div>
    );
  }


  // ========================
  // ERROR
  // ========================

  else if (isError) {

    content = (
      <div className="alert alert-danger">
        {error?.data?.message || "Something went wrong"}
      </div>
    );

  }


  // ========================
  // SUCCESS
  // ========================

  else if (isSuccess) {

    const images = data?.data || [];

    content = (

      <table className="table table-striped table-bordered align-middle">

        <thead className="table-dark">

          <tr>
            <th style={{ width: "120px" }}>Preview</th>
            <th>Title</th>
            <th>Event</th>
            <th>Category</th>
            <th>Featured</th>
            <th style={{ width: "160px" }}>Actions</th>
          </tr>

        </thead>

        <tbody>

          {images.length === 0 && (

            <tr>
              <td colSpan="6" className="text-center py-4">
                No images found
              </td>
            </tr>

          )}

          {images.map((image) => (

            <tr key={image._id}>

              {/* PREVIEW */}

              <td>

                <img
                  src={image.image?.url}
                  alt={image.title || "gallery"}
                  width="100"
                  height="70"
                  style={{
                    objectFit: "cover",
                    borderRadius: "6px",
                  }}
                />

              </td>


              {/* TITLE */}

              <td>{image.title || "-"}</td>


              {/* EVENT */}

              <td>{image.event?.title || "-"}</td>


              {/* CATEGORY */}

              <td>{image.category?.title || "-"}</td>


              {/* FEATURED */}

              <td>

                {image.isFeatured ? (

                  <span className="badge bg-success">
                    Yes
                  </span>

                ) : (

                  <span className="badge bg-secondary">
                    No
                  </span>

                )}

              </td>


              {/* ACTIONS */}

              <td>

                <Link
                  to={`/dashboard/gallery/${image._id}`}
                  className="btn btn-sm btn-primary me-2"
                >
                  Edit
                </Link>

                <button
                  onClick={() => handleDelete(image._id)}
                  className="btn btn-sm btn-danger"
                  disabled={isDeleting}
                >
                  Delete
                </button>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

    );

  }


  return (

    <div className="container mt-4">

      <div className="d-flex justify-content-between align-items-center mb-4">

        <h2>Gallery Images</h2>

        <div>

          <Link
            to="/dashboard/gallery/new"
            className="btn btn-primary me-2"
          >
            + New Image
          </Link>

          <Link
            to="/dashboard/gallery/bulk-upload"
            className="btn btn-success"
          >
            Bulk Upload
          </Link>

        </div>

      </div>

      {content}

    </div>

  );

};

export default GalleryImageList;